import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Gauge, Activity, Download, Loader2, Wifi } from "lucide-react";

function Stat({ icon: Icon, label, value, unit, color }) {
  return (
    <div className="flex-1 rounded-xl border border-black/5 bg-white/70 p-3 text-center">
      <div
        className="mx-auto mb-2 flex h-9 w-9 items-center justify-center rounded-lg"
        style={{ backgroundColor: color + "1A", color }}
      >
        <Icon size={18} strokeWidth={2.2} />
      </div>
      <div className="text-[20px] font-bold leading-none text-[#0A0A0A]">
        {value ?? "—"}
        {value != null && unit && (
          <span className="ms-1 text-[11px] font-medium text-[#94A3B8]">{unit}</span>
        )}
      </div>
      <div className="mt-1 text-[11px] text-[#52525B]">{label}</div>
    </div>
  );
}

export default function SpeedPanel({ open, onClose, loading, result }) {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 z-30 bg-black/20 backdrop-blur-[2px]"
          />
          <motion.div
            initial={{ scale: 0.94, opacity: 0, y: 10 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.94, opacity: 0, y: 10 }}
            transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
            dir="rtl"
            className="absolute left-1/2 top-1/2 z-40 w-[440px] max-w-[calc(100vw-2rem)] -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-white/60 bg-white/90 p-5 shadow-2xl backdrop-blur-xl"
            data-testid="speed-panel"
          >
            <div className="mb-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Gauge size={18} className="text-[#0055FF]" />
                <h2 className="text-[15px] font-bold text-[#0A0A0A]">מהירות ואיחור רשת</h2>
              </div>
              <button
                onClick={onClose}
                className="rounded-lg p-1 text-[#52525B] transition-colors hover:bg-black/5"
              >
                <X size={18} />
              </button>
            </div>

            {loading ? (
              <div className="flex flex-col items-center gap-3 py-10 text-center text-[#52525B]">
                <Loader2 size={26} className="animate-spin text-[#0055FF]" />
                <p className="text-[13px]">בודק מהירות ואיחור...</p>
              </div>
            ) : (
              <>
                <div className="flex gap-2" data-testid="speed-results">
                  <Stat
                    icon={Activity}
                    label="איחור לנתב"
                    value={result?.router_latency_ms}
                    unit="ms"
                    color="#0055FF"
                  />
                  <Stat
                    icon={Wifi}
                    label="איחור לאינטרנט"
                    value={result?.internet_latency_ms}
                    unit="ms"
                    color="#8B5CF6"
                  />
                  <Stat
                    icon={Download}
                    label="הורדה"
                    value={result?.download_mbps}
                    unit="Mbps"
                    color="#10B981"
                  />
                </div>
                {result?.note === "download_unavailable" && (
                  <p className="mt-3 text-center text-[11px] text-[#94A3B8]">
                    לא ניתן היה למדוד מהירות הורדה (אין גישה לאינטרנט מהשרת). האיחור לנתב עדיין נמדד.
                  </p>
                )}
                {result?.gateway && (
                  <p className="mt-3 text-center font-mono text-[11px] text-[#94A3B8]" dir="ltr">
                    router {result.gateway}
                  </p>
                )}
              </>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
